import React, {useCallback, useMemo, useState} from 'react';

export interface HeaderCapabilityOption {
  readonly id: number;
  readonly name: string;
  readonly type?: string;
}

export interface TopHeaderProps {
  readonly modelLabel?: string;
  readonly onClickUpgrade?: () => void;

  /** 传入可选模型列表时，顶部展示下拉选择 */
  readonly capabilities?: readonly HeaderCapabilityOption[];
  readonly currentCapabilityId?: number;
  readonly onSelectCapability?: (id: number) => void;
}

export const TopHeader: React.FC<TopHeaderProps> = ({
  modelLabel,
  onClickUpgrade,
  capabilities,
  currentCapabilityId,
  onSelectCapability
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const hasDropdown: boolean = !!capabilities && capabilities.length > 0;

  const currentOption: HeaderCapabilityOption | undefined = useMemo(() => {
    if (!hasDropdown) {
      return undefined;
    }
    const match: HeaderCapabilityOption | undefined =
      capabilities?.find(item => item.id === currentCapabilityId) ??
      capabilities?.[0];
    return match;
  }, [capabilities, currentCapabilityId, hasDropdown]);

  const displayLabel: string =
    currentOption?.name ?? modelLabel ?? '智能助手 v2.6';

  const handleToggle = useCallback((): void => {
    if (!hasDropdown) {
      return;
    }
    setOpen(prev => !prev);
  }, [hasDropdown]);

  const handleSelect = useCallback(
    (id: number): void => {
      onSelectCapability?.(id);
      setOpen(false);
    },
    [onSelectCapability]
  );

  return (
    <header className="header">
      <div className="header-left">
        {hasDropdown ? (
          <div className="header-model-wrapper">
            <button
              type="button"
              className="header-model-trigger"
              onClick={handleToggle}
            >
              <i className="fa-solid fa-snowflake" />
              <span className="header-model-name">{displayLabel}</span>
              {currentOption?.type ? (
                <span className="header-model-tag">{currentOption.type}</span>
              ) : null}
              <i
                className={`fa-solid fa-chevron-${
                  open ? 'up' : 'down'
                } header-model-arrow`}
              />
            </button>

            {open ? (
              <div className="header-model-menu">
                {capabilities?.map(item => (
                  <button
                    key={item.id}
                    type="button"
                    className={`header-model-item${
                      item.id === currentOption?.id ? ' active' : ''
                    }`}
                    onClick={(): void => handleSelect(item.id)}
                  >
                    <div className="header-model-item-main">
                      <span className="header-model-item-name">
                        {item.name}
                      </span>
                      {item.type ? (
                        <span className="header-model-item-type">
                          {item.type}
                        </span>
                      ) : null}
                    </div>
                    {item.id === currentOption?.id ? (
                      <i className="fa-solid fa-check header-model-check" />
                    ) : null}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        ) : (
          <div className="model-select">
            <i className="fa-solid fa-snowflake" />
            {displayLabel}{' '}
            <i
              className="fa-solid fa-chevron-down"
              style={{fontSize: 10}}
            />
          </div>
        )}
      </div>

      <button
        className="upgrade-btn"
        onClick={onClickUpgrade}
        type="button"
      >
        <i className="fa-solid fa-wand-magic-sparkles" /> <span>升级会员</span>
      </button>
    </header>
  );
};